import React from "react";
import DiscountedPriceComponent from "../Generic/DiscountedPriceComponent";
import {
  calculatePricePerUnit,
  formatDecimalNumber,
} from "../../config_and_helpers/helpers";

/**
 * Renders the display of product prices.
 *
 * @param {object} product - The product information.
 * @param {number} productDiscountedConvertedPrice - The converted discounted price of the product.
 * @param {number} productRetailConvertedPrice - The converted retail price of the product.
 * @param {number} pricePerSmallestUnit - The price per smallest unit of the product.
 * @param {object} currencyRates - The currency rates for conversion.
 * @param {boolean} productHasSubUnits - Indicates if the product has subunits.
 * @param {string} viewSource - The source of the view.
 * @returns {JSX.Element} - The rendered product price display.
 */
const ProductPriceDisplay = ({
  product,
  productDiscountedConvertedPrice,
  productRetailConvertedPrice,
  pricePerSmallestUnit,
  currencyRates,
  productHasSubUnits,
  viewSource = "inventoryModal",
}) => {
  return (
    <>
      {productRetailConvertedPrice ? (
        <div>
          {product.discount === null ? (
            <div
              className={`d-flex flex-column ${
                viewSource !== "offCanvas" && "align-items-center"
              }`}
            >
              <span className={`${viewSource !== "offCanvas" && "mt-3"}`}>
                {product.price !== null
                  ? `Retail Price: ${productDiscountedConvertedPrice}₪, ${calculatePricePerUnit(
                      productDiscountedConvertedPrice,
                      product.unit_quantity,
                    )}₪ per ${productHasSubUnits ? "Subunit" : product.unit}`
                  : ""}
              </span>
              {product.price && (
                <span className="mt-2 fw-bold">{`Price/Smallest Unit: ${pricePerSmallestUnit}₪`}</span>
              )}
            </div>
          ) : (
            <div>
              <div>
                <span>
                  Retail Price: {productRetailConvertedPrice}
                  {`₪, ${calculatePricePerUnit(
                    productRetailConvertedPrice,
                    product.unit_quantity,
                  )}₪ per ${productHasSubUnits ? "Subunit" : product.unit}`}
                </span>
              </div>
              <div
                className={`d-flex flex-column ${
                  viewSource !== "offCanvas" && "align-items-center"
                }`}
              >
                <span className="d-flex flex-row">
                  <DiscountedPriceComponent
                    product={product}
                    currencyRates={currencyRates}
                    convertCurrency={true}
                    discountedPricePerUnit={calculatePricePerUnit(
                      productDiscountedConvertedPrice,
                      product.unit_quantity,
                    )}
                  />
                  <span className="ms-1 fw-bold">
                    (-{formatDecimalNumber(product.discount)}%)
                  </span>
                </span>
                <span className="mt-2 fw-bold">{`Price/Smallest Unit: ${pricePerSmallestUnit}₪`}</span>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="fw-bold">Price not available</div>
      )}
    </>
  );
};
export default ProductPriceDisplay;
